import api from './api';

// Token handling utilities
export const getAccessToken = () => localStorage.getItem('accessToken');
export const getRefreshToken = () => localStorage.getItem('refreshToken');

export const setTokens = ({ accessToken, refreshToken }) => {
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

// Login
export const login = async (email, password) => {
  // Hit your /auth/login endpoint
  const { data } = await api.post('/auth/login', { email, password });
  // data.data is expected to contain { accessToken, refreshToken }
  setTokens(data.data);
  return data.data;
};

// Refresh Token
export async function refreshToken() {
  const token = getRefreshToken(); // Get the current refresh token from storage
  if (!token) {
    throw new Error('No refresh token available');
  }

  try {
    const { data } = await api.post('/auth/refresh', { refreshToken: token });
    
    // Store the new tokens
    setTokens(data.data); // data.data contains { accessToken, refreshToken }
    return data.data.accessToken;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    throw new Error('Failed to refresh token');
  }
}

//Logout
export async function logoutUser() {
  try {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      throw new Error('No refresh token found.');
    }

    // Call the backend logout endpoint with the refresh token
    await api.post('/auth/logout', { refreshToken });
  } catch (error) {
    console.error('Failed to logout on the server:', error);
    throw new Error('Failed to logout on the server.');
  } finally {
    // Clear tokens and redirect the user to the login page
    clearTokens();
    window.location.href = '/login';
  }
}
